import { get, isArray } from 'lodash';
import React from 'react';
import { FOERDERPROGRAMM_ALLGEMINE_HINWEISE_MA_PATHS, FOERDERPROGRAMM_DATEIEN_JE_MA_PATHS } from 'src/lib/constants/componentsPath';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import AllgemeinHinweisGlobal from '../../../global-structure/allgemeinen-hinweis/content/AllgemeinHinweisGlobal';

// import schemas
import MittelAbrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import DownloadsMA from './content/DownloadsMA';
const MA_P = MittelAbrufSchema.attributes;

export const TreeStructureWichtigeHinweiseMA = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Wichtige Hinweise',
			content: <ApplicationHeading title='Wichtige Hinweise' />,
			children: WichtigeHinweiseChildren(application),
		},
	];
	return treeNodes;
};

const WichtigeHinweiseChildren = (application: any): TreeNodeType[] => {
	const foerderprogramm = get(application, MA_P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	const hinweisBlock_ARR = get(foerderprogramm, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_MA_PATHS.HinweisBlock, []);
	const programmSpezifischDateien = get(foerderprogramm, FOERDERPROGRAMM_DATEIEN_JE_MA_PATHS.DateienBlock, []);
	const hasDateien = isArray(programmSpezifischDateien) && programmSpezifischDateien.some((item: any) => item?.Datei);

	const hinweisNodes: TreeNodeType[] = hinweisBlock_ARR.map((ele: any) => {
		return {
			label: get(ele, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_MA_PATHS.Titel, ''),
			content: <AllgemeinHinweisGlobal eachHinweis={ele} hinweisPath={FOERDERPROGRAMM_ALLGEMINE_HINWEISE_MA_PATHS} />,
		};
	});
	const dateienNodes: TreeNodeType = {
		label: 'Downloads',
		content: <DownloadsMA />,
	};

	const nodes: TreeNodeType[] = [...hinweisNodes];
	if (hasDateien) {
		nodes.push(dateienNodes);
	}

	return nodes;
};
